import * as React from 'react';

import './overview-header.css';

interface OverviewHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  clientPortalName?: string;
  clientLogo?: string;
  clientName?: string;
  userSection: React.ReactNode;
}

const OverviewHeader = React.forwardRef<HTMLDivElement, OverviewHeaderProps>(
  (
    { clientLogo, clientName, clientPortalName, userSection, ...props },
    ref,
  ) => {
    return (
      <div className="overview-header" ref={ref} {...props}>
        <div className="overview-header-content">
          <div className="overview-header-content-info">
            <img src={clientLogo} alt={`${clientName} Logo`} />
            <div className="overview-header-content-info-text">
              <span className="overview-header-content-info-text-title">
                Welcome to {clientPortalName}
              </span>
              <span className="overview-header-content-info-text-subtitle">
                Powered by Gemini Diversified Services
              </span>
            </div>
          </div>
          <div className="overview-header-user-section">{userSection}</div>
        </div>
      </div>
    );
  },
);

export { OverviewHeader };
